import React, { Component } from 'react'
import { connect } from 'react-redux'
import img404 from '../../assets/404.png'
import Logo from '../../assets/logo-intro.svg'
import './style.css'

class Error extends Component {
  render () {
    return (
      <div className='error flex items-center'>
        <div className='content w-100 pa4 tc flex flex-column justify-center'>
          <div className='pa0'><img src={Logo} style={{ width: '15%', minWidth: '100px' }} /></div>
          <div className='pt4 pt5-l'><img src={img404} style={{ width: '20%' }} /></div>
          <div className='pt2 lh-copy'>The page you're looking for does not exist.</div>
          <div className='pt5 pt5-l'>
            <a className='cta tbutton clear white flex' href='https://www.roadsafetyeducation.vic.gov.au/educational-resources/programs/roadsmart-interactive'>BACK TO HOMEPAGE</a>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({})

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Error)
